import { useEffect, MouseEvent } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { useWorkRulesTable } from 'hooks/workRules/useWorkRulesTable';
import { ContextMenu } from './ContextMenu';

const WorkRuleTable = () => {
    const { t } = useTranslation();
    const { rows, loading, selectedRow, setSelectedRow, contextMenu, setContextMenu, selected, setSelected, columns, reloading } = useWorkRulesTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
    };

    return (
        <div style={{ width: '100%', height: '100%' }} onContextMenu={handleContextMenu}>
            <DataGridPro
                sx={{
                    height: 'calc(100vh - 140px)',
                    cursor: 'default',
                    '& .MuiDataGrid-cell': {
                        cursor: 'pointer',
                    },
                }}
                columns={columns}
                rows={rows}
                showCellVerticalBorder
                showColumnVerticalBorder
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'name', sort: 'asc' }],
                    },
                }}
                headerFilters
                localeText={{
                    headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                    headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                    headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                    headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                    headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                    headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                    footerRowSelected: (count) =>
                        count > 1
                            ? `${t('general.table.footerFilters.footerRowSelected.>1', { count, countFormatted: count.toLocaleString() })} `
                            : `${t('general.table.footerFilters.footerRowSelected.=1', { count, countFormatted: count.toLocaleString() })}`,
                    footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                    MuiTablePagination: {
                        labelDisplayedRows: ({ from, to, count }) =>
                            t('general.table.footerFilters.labelDisplayedRows', {
                                from,
                                to,
                                count,
                            }),
                        labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                    },
                }}
                disableColumnMenu
                loading={loading}
                checkboxSelection
                rowSelectionModel={selected}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    let row = rows.filter((row: any) => newRowSelectionModel.includes(row.id));
                    setSelected(newRowSelectionModel);
                    setSelectedRow(row);
                }}
                pagination
            />

            <ContextMenu contextMenu={contextMenu} setContextMenu={setContextMenu} selectedRow={selectedRow} reloading={reloading} rows={rows} />
        </div>
    );
};

export default WorkRuleTable;
